/* eslint-disable react/prop-types */
import Popover from '../../Popover';
import { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSavedList } from '../../../store/reducers/location';
import { HomeIcon, MoreIcon, OfficeIcon, PencilEditIcon, TagIcon } from '../../../utils/svg';
import { MapPinIcon, TrashIcon } from '@heroicons/react/24/solid';
import { authHeaders, axiosInstance, isEmptyData, logError } from '../../../utils/helper';
import { setUser } from '../../../store/reducers/user';
import { BottomSheet } from 'react-spring-bottom-sheet';
import Address from '../../address';

const Delete = (props) => {
	const { onClose = () => {}, data = null } = props;

	const dispatch = useDispatch();
	const user = useSelector((state) => state.user);
	const [isLoading, setIsLoading] = useState(false);

	const handleSubmit = async () => {
		if (isEmptyData(data)) return;
		setIsLoading(true);
		const formData = new FormData();
		formData.append('user_id', user?.customerID);
		formData.append('id_customer_address', data.id);
		try {
			const response = await axiosInstance.post(`address/delete`, formData, authHeaders());
			if (response.status === 200) {
				onClose();
				dispatch(getSavedList(user?.customerID));
			}
			setIsLoading(false);
		} catch (error) {
			setIsLoading(false);
		}
	};

	return (
		<BottomSheet key={'delete-address'} open={!isEmptyData(data)} onDismiss={onClose}>
			<div className='p-4'>
				<p className='text-[var(--dark-gray)] font-semibold text-sm px-6 mb-1.5 text-center'>Hapus alamat Anda yang tersimpan?</p>
				<p className='text-[var(--dark-gray)] text-xxs mb-8 text-center'>Alamat yang tersimpan memudahkan Anda memilih lokasi pengiriman lalu mengatur alamat secara manual setiap kali Anda memesan.</p>
				<div className='grid grid-cols-2 gap-4'>
					<button
						id='search_address_cancel_delete'
						className='capitalize border border-solid border-[var(--rose-violet)] text-[var(--rose-violet)] w-full py-2.5 text-center text-xs font-semibold rounded hover:bg-[var(--rose-violet)] hover:text-white transition-all disabled:cursor-not-allowed disabled:opacity-50'
						onClick={onClose}
						disabled={isLoading}>
						Batal
					</button>
					<button
						id='search_address_confirm_delete'
						className='capitalize border border-solid border-[var(--rose-violet)] bg-[var(--rose-violet)] text-white w-full py-2.5 text-center text-xs font-semibold rounded hover:bg-[var(--rose-violet)]/80 transition-all disabled:cursor-not-allowed disabled:opacity-50'
						onClick={handleSubmit}
						disabled={isLoading}>
						Ya, Tentu
					</button>
				</div>
			</div>
		</BottomSheet>
	);
};

const Options = (props) => {
	const { item, index, setDeleteData, setEditData } = props;
	const [showOption, setShowOption] = useState(null);

	return (
		<Popover
			content={
				<div className='rounded-md border border-solid border-[var(--pin-ball)] bg-white w-[140px] shadow-custom'>
					<div id='search_address_edit_location' className='px-3 py-2.5 border-b border-solid border-[var(--pin-ball)] flex justify-between items-center' onClick={() => setEditData(item)}>
						<span className='text-[var(--dark-gray)] font-semibold text-xs'>Ubah</span>
						<PencilEditIcon className='h-4 w-4 fill-gray-600' />
					</div>
					<div id='search_address_delete_location' className='px-3 py-2.5 flex justify-between items-center' onClick={() => setDeleteData(item)}>
						<span className='text-[var(--dark-gray)] font-semibold text-xs'>Hapus</span>
						<TrashIcon className='h-4 w-4 fill-gray-600' />
					</div>
				</div>
			}
			show={showOption === index}
			setShow={(value) => {
				setShowOption(value ? index : null);
			}}>
			<MoreIcon className={`h-7 w-7  ${Number(item?.primary) ? 'fill-rose-violet' : 'fill-gray-500'}`} />
		</Popover>
	);
};

const Saved = (props) => {
	const { onClose } = props;

	const [isShowBottomSheet, setIsShowBottomSheet] = useState(false);
	const [editData, setEditData] = useState(null);
	const [deleteData, setDeleteData] = useState(null);

	const dispatch = useDispatch();
	const { savedData } = useSelector((state) => state.location);

	const handleIcon = (item = {}) => {
		switch (item?.type) {
			case 'home':
				return <HomeIcon className={`h-12 w-12 ${Number(item?.primary) ? 'fill-rose-violet' : 'fill-gray-400'}`} />;
			case 'office':
				return <OfficeIcon className={`h-12 w-12 ${Number(item?.primary) ? 'fill-rose-violet' : 'fill-gray-400'}`} />;
			default:
				return <TagIcon className={`h-12 w-12 -rotate-90 ${Number(item?.primary) ? 'fill-rose-violet' : 'fill-gray-400'}`} />;
		}
	};

	const handleSetPrimaryAddress = async (location = null) => {
		try {
			const headers = {
				'Content-Type': 'application/json',
        ...authHeaders().headers
			};

			const data = JSON.stringify({
				user_id: location?.user_id,
				id_customer_address: location?.id,
			});
			await axiosInstance.post(`address/primary-address`, data, { headers });
		} catch (error) {
			console.log('error', error.response.data.message);

      logError(error, {feature: "handleSetPrimaryAddress"});
		}
	};

	const handleSelect = async (data = null) => {
		if (isEmptyData(data?.latitude) || isEmptyData(data?.longitude)) return;
		dispatch(
			setUser({
				addressName: data?.address_name,
				address: data?.address,
				latitude: Number(data?.latitude),
				longitude: Number(data?.longitude),
				country: data?.country,
				state: data?.state,
				city: data?.city,
				village: data?.village,
				district: data?.district,
				postalCode: data?.postal_code ?? '',
				detail: data?.address_detail,
				firstName: data?.contact_name,
				primary_phone: data?.contact_number,
			}),
		);
		handleSetPrimaryAddress(data);
		onClose?.();
	};

	const handleClick = async (data = null) => {
		setIsShowBottomSheet(true);
		if (!isEmptyData(data)) {
			setEditData(data);
		}
	};

	const handleCloseBottomSheet = () => {
		setIsShowBottomSheet(false);
		setEditData(null);
	};

	const handleCloseDelete = () => {
		setDeleteData(null);
	};

	const addressProps = useMemo(() => {
		return {
			onClose: handleCloseBottomSheet,
			data: editData,
		};
	}, [editData]);

	const deleteProps = useMemo(() => {
		return {
			onClose: handleCloseDelete,
			data: deleteData,
		};
	}, [deleteData]);

	return (
		<>
			<div className='relative mb-4'>
				<div className={`${savedData?.length ? 'flex justify-between items-center mb-4' : 'flex flex-col gap-4'}`}>
					<span className='text-[var(--dark-gray)] font-semibold text-sm'>Alamat yang disimpan</span>
					{savedData?.length ? (
						<span id='save_address_add_new' className='cursor-pointer font-semibold text-xs text-[var(--rose-violet)]' onClick={handleClick}>
							Tambah
						</span>
					) : (
						<button
							className='capitalize border border-solid border-[var(--rose-violet)] bg-white text-[var(--rose-violet)] w-full py-3 text-center text-xs font-semibold rounded hover:bg-steam/10 transition-all flex gap-1 items-center justify-center'
							onClick={handleClick}>
							<MapPinIcon className='h-3 w-3 text-rose-violet' />
							<span>Tambah Alamat Baru</span>
						</button>
					)}
				</div>
				{Boolean(savedData?.length) && (
					<div className='space-y-2'>
						{savedData?.map((item, index) => (
							<div key={index} className={`px-4 py-2.5 border border-solid rounded-md flex justify-between items-center gap-5 relative ${Number(item?.primary) ? 'border-rose-violet' : 'border-gray-300'}`}>
								<div className='flex gap-2.5 items-center'>
									{handleIcon(item)}
									<div
										className='space-y-0.5'
										onClick={() => {
											handleSelect(item);
										}}>
										<p className='text-gray-700 text-sm font-semibold'>{item?.address_name}</p>
										<p className='text-gray-500 text-xxs'>{item?.address}</p>
									</div>
								</div>
								<Options {...{ item, index, setDeleteData, setEditData: handleClick }} />
							</div>
						))}
					</div>
				)}
			</div>
			<Delete {...{ ...deleteProps }} />
			<BottomSheet key={'form-address'} open={isShowBottomSheet} onDismiss={handleCloseBottomSheet}>
				<Address {...addressProps} />
			</BottomSheet>
		</>
	);
};

export default Saved;
